import { CompositeScreenProps } from '@react-navigation/native'
import React from 'react'
import { ScrollView } from 'react-native'

import { Page } from 'partials/Page'
import { ReferralView } from 'partials/ReferralView'

import { Separator } from 'widgets/Separator'

import { useUser } from 'hooks/useUser'

export const ShareUpspacePage = ({ navigation, route }: CompositeScreenProps<any, any>) => {
  const username = route?.params?.username
  const {
    data: user,
    error,
    isLoading,
  } = useUser({
    username,
  })

  return (
    <Page
      withBack
      withNav
      backgroundColor='white'
      title={`${user?.firstName} ${user?.lastName}'s Group`}
      navigation={navigation}
    >
      <Separator />
      <ScrollView>
        {user && !isLoading && !error && <ReferralView user={user} mode='coach' />}
      </ScrollView>
    </Page>
  )
}
